import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useParams } from 'react-router';

import { useGetForm } from 'api/hooks/private/forms/GetForm';

import { PageContainer } from 'components/PageContainer';

import useSearchParamState from 'hooks/useSearchParamState';

import EmailTemplate from './Tabs/EmailTemplate';
import Preview from './Tabs/Preview';

type PackageTabs = 'preview' | 'email_template';

export function ManagePackage() {
  // get the form id
  const { id } = useParams<{ id: string }>();
  const [tabValue, setTabValue] = useSearchParamState({
    paramName: 'tab',
    initialState: 'preview',
    serialize: String,
    deserialize: String,
  });

  // fetch the form
  const form = useGetForm({
    variables: {
      id: id ?? '',
    },
    enabled: !!id,
  });

  const handleSetTabValue = (_event: React.SyntheticEvent, newValue: PackageTabs) => {
    setTabValue(newValue);
  };

  return (
    <PageContainer title={form.data?.name}>
      <Tabs
        value={tabValue}
        onChange={handleSetTabValue}
        sx={{
          background: 'transparent',
          ml: -2,
          marginBottom: 2,
        }}
      >
        <Tab value="preview" label="Preview" />
        <Tab value="email_template" label="Email Template" />
      </Tabs>

      {id && tabValue === 'preview' && <Preview formId={id} />}
      {id && tabValue === 'email_template' && <EmailTemplate formId={id} />}
    </PageContainer>
  );
}

export default ManagePackage;
